import React, { ReactElement, useEffect, useRef } from "react";
import { Button, Col, Divider, Flex, Form, Input, InputNumber, List, notification, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import Boleto from "../../../../Models/Financeiro/Titulo/Pagamento/Boleto";
import Origem from "../../../../Models/Financeiro/Titulo/Origem";
import OrigemSelect from "./Origem/OrigemSelect";
import PessoaSelectComTipo from "../../Pessoa/PessoaSelect";
import RateioForm from "./Rateio/RateioForm";
import RateioTableBasic from "./Rateio/RateioTableBasic";
import Titulo from "../../../../Models/Financeiro/Titulo/Titulo";
import TituloSituacaoSelect from "./TituloSituacao/TituloSituacaoSelect";
import Utilitario from "../../../../Utils/Utilitario";

import { EnumPagamentoTipo } from "../../../../Models/Financeiro/Titulo/Pagamento/PagamentoTipo";
import { EnumPessoaTipo } from "../../../../Models/Pessoa/Pessoa";
import { EnumTituloSituacao } from "../../../../Models/Financeiro/Titulo/TituloSituacao";
import { PropriedadesDeNotificacao } from "../../../../Utils/Notificacoes";
import { useBuscar, useSalvar } from "@/Services/Financeiro/Titulo/TituloService";

import dayjs from "dayjs";
import { BooleanProps, RecursivePartial } from "../../../../utility-types";
import { EnumOrigemTipo } from "../../../../Models/Financeiro/Titulo/Origem/OrigemTipo";
import { Movimentacao } from "@/Models/Financeiro/Conta/Movimentacao";
import { useNavigate } from "react-router-dom";
import TituloCadastroScreen from "./TituloCadastroScreen";

export interface ITituloFormBasicTipoProps {
    defaultValues?: Titulo<any>;
    disable?: BooleanProps<FormType & { }>;
}

export interface ITituloFormBasicProps extends FormProps<FormType> {
    codigo?: number;
    onErroBuscarTitulo?:() => void;
    isAReceber?: boolean;
    aReceberProps?:ITituloFormBasicTipoProps;
    aPagarProps?:ITituloFormBasicTipoProps;
    onFinish?: (titulo: FormType, movimentacao?: MovimentacaoFormType ) => any
}

export interface ITituloFormProps extends ITituloFormBasicProps {
    buttoCencelar?: ReactElement;
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSalvarSucesso?: (codTitulo: number | null) => void;
}

export default function TituloForm(
    {
        buttoCencelar,
        onCancelar : onCancelarParam,
        onSalvarSucesso,
        codigo,
        isAReceber,
        ...props
    } : ITituloFormProps
): JSX.Element {
    const navigate = useNavigate();

    function onCancelar(evento: React.MouseEvent<HTMLElement, MouseEvent>) {
        if (onCancelarParam)
            onCancelarParam?.(evento);
        else
        {
            if (window.history.length <= 1)
                window.close();
            else 
                navigate(-1);
        }
    }

    return <TituloCadastroScreen
        {...props}
        codigo={codigo}
        isAReceber={isAReceber}
        onCancelar={onCancelar}
        onSalvarSucesso={onSalvarSucesso}
    />
}
